import React from "react";

import { string, object, func, bool, array } from "prop-types";

import { MultiInput, RadioCard, TextFieldGroup } from "../../../common";
import * as style from "./styles.module.scss";
import SpacedOutText from "../../../common/SpacedOutText";
import RadioButton from "../../../common/RadioButton";

const PayrollForm = ({
  isDBSConsentVisible,
  bankName,
  accountNumber,
  sortCode,
  accountName,
  nationalInsuranceNo,
  dbsConsent,
  taxTypeEmployeeStatement,
  validation,
  handleChange,
  taxTypeOptions,
  blurredElements,
  setBlurred,
  validUkAccSortCode,
}) => {
  const validUkAccSortCodeCond = () => {
    if (validUkAccSortCode) return <span className={style.checkmark}></span>;
    if (accountNumber.length >= 8 && sortCode.length >= 6)
      return <span className={style.cross}> X </span>;
    return null;
  };

  return (
    <form>
      <section className="mb-2">
        <div className={style.sectionCard}>
          <div className={`form-group ${style.formGroup}`}>
            <div className="d-flex align-items-baseline">
              <label
                htmlFor="nationalInsuranceNo"
                className={
                  blurredElements.nationalInsuranceNo &&
                  validation.nationalInsuranceNo
                    ? style.redLabel
                    : ""
                }
              >
                National Insurance Number
              </label>
            </div>
            <TextFieldGroup
              classes="register_field col-6 col-sm-4"
              value={nationalInsuranceNo}
              placeholder="e.g. QQ123456C"
              validationMessages={
                blurredElements.nationalInsuranceNo &&
                validation.nationalInsuranceNo
              }
              validationMessageIsRed={true}
              onChange={(e) => {
                handleChange("nationalInsuranceNo", e.target.value.trim());
              }}
              onBlur={() => {
                setBlurred("nationalInsuranceNo");
              }}
            />
          </div>
          <div className={`form-group ${style.formGroup}`}>
            <div className="d-flex align-items-baseline">
              <label htmlFor="bankName">Name of bank</label>
            </div>
            <TextFieldGroup
              classes="register_field col-12 col-sm-6"
              value={bankName}
              placeholder="e.g. HSBC"
              onChange={(e) => {
                handleChange("bankName", e.target.value);
              }}
            />
          </div>
          <div className={`form-group ${style.formGroup}`}>
            <div className="d-flex align-items-baseline">
              <label
                htmlFor="accountNumber"
                className={
                  blurredElements.accountNumber && validation.accountNumber
                    ? style.redLabel
                    : ""
                }
              >
                Account Number
              </label>
              {validUkAccSortCodeCond()}
            </div>
            <TextFieldGroup
              classes="register_field col-6 col-sm-4"
              value={accountNumber}
              validationMessages={
                blurredElements.accountNumber && validation.accountNumber
              }
              validationMessageIsRed={true}
              placeholder="12345678"
              onChange={(e) => {
                handleChange("accountNumber", e.target.value.trim());
              }}
              onBlur={() => {
                setBlurred("accountNumber");
              }}
            />
          </div>
          <div className={`form-group ${style.formGroup}`}>
            <div className="d-flex align-items-baseline">
              <label
                htmlFor="sortCode"
                className={
                  blurredElements.sortCode && validation.sortCode
                    ? style.redLabel
                    : ""
                }
              >
                Sort Code
              </label>
              {validUkAccSortCodeCond()}
            </div>
            <MultiInput
              classes="register_field"
              value={sortCode}
              numberOfInputs={3}
              placeholder="987654"
              inputId="sortCode"
              onlyShowValidationAfterChange={true}
              onChange={(e) => handleChange("sortCode", e.target.value)}
              validationMessages={
                blurredElements.sortCode && validation.sortCode
              }
              onBlur={() => {
                setBlurred("sortCode");
              }}
            />
          </div>
          <div className={`form-group ${style.formGroup}`}>
            <div className="d-flex align-items-baseline">
              <label htmlFor="accountName">Name on account</label>
            </div>
            <TextFieldGroup
              classes="register_field col-12 col-sm-6"
              value={accountName}
              placeholder="e.g. Mr John Smith"
              onChange={(e) => {
                handleChange("accountName", e.target.value);
              }}
            />
          </div>
        </div>
      </section>
      <section>
        <h4 className={style.sectionHeader}>
          Please select the statement that applies to you
        </h4>
        {taxTypeOptions.map((option) => (
          <RadioCard
            isChecked={taxTypeEmployeeStatement === option.value}
            onChange={() =>
              handleChange("taxTypeEmployeeStatement", option.value)
            }
            key={option.value}
          >
            <h2 className={style.cardHeader}>{option.title}</h2>
            {option.info}
            {option.text}
          </RadioCard>
        ))}
      </section>
      {isDBSConsentVisible && (
        <section className="mt-2">
          <h4 className={style.sectionHeader}>DBS consent</h4>
          <div className={style.sectionCard}>
            <div className="form-group mb-0">
              <SpacedOutText>
                <small className="form-text mb-2">
                  I consent to the DBS (formerly CRB) checking the details I
                  have provided in support of this application against the data
                  sources specified in the notes for guidance, in order to
                  verify my identity and process this application. These details
                  may be recorded and used to assist other organisations for
                  identity and verification purposes. I agree to an amount of
                  £30.00 will be deducted from my first weeks salary unless
                  otherwise stated in my starter letter.
                </small>
              </SpacedOutText>
              <RadioButton
                isChecked={dbsConsent === true}
                onClick={() => {
                  handleChange("dbsConsent", true);
                }}
                label={"Yes"}
              />
              <RadioButton
                isChecked={dbsConsent === false}
                onClick={() => {
                  handleChange("dbsConsent", false);
                }}
                label={"No"}
              />
            </div>
          </div>
        </section>
      )}
    </form>
  );
};

PayrollForm.propTypes = {
  isDBSConsentVisible: bool.isRequired,
  bankName: string.isRequired,
  accountNumber: string.isRequired,
  sortCode: string.isRequired,
  accountName: string.isRequired,
  nationalInsuranceNo: string.isRequired,
  dbsConsent: bool,
  taxTypeEmployeeStatement: string.isRequired,
  validation: object.isRequired,
  handleChange: func.isRequired,
  taxTypeOptions: array,
  blurredElements: object,
  setBlurred: func,
  validUkAccSortCode: bool,
};

export default PayrollForm;
